// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabCmpEmpresas extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.cmp_empresas";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabCmpEmpresas {
        this.VALUES ??= this.completar({
            "valor": {
                "ca-ES": "Característiques",
                "cz": "Společnosti",
                "da": "Leverandører",
                "de": "Unternehmen",
                "en": "Vendors",
                "eu-ES": "Enpresak",
                "fi": "Toimittaja",
                "fr": "Partenaires",
                "ga-ES": "Empresas",
                "hi": "विक्रेताओं",
                "hu": "Szállítók",
                "it": "Società",
                "no": "Leverandører",
                "nl": "Bedrijven",
                "pl": "Firmy",
                "pt": "Empresas",
                "ro": "Companii",
                "ru": "Компании",
                "sv": "Leverantörer",
                "sk": "Spoločnosti"
            },
            "defecto": "Empresas"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
